import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=d1fb6a78&scoped=true&"
import script from "./ComplaintList.vue?vue&type=script&lang=ts&"
export * from "./ComplaintList.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintList.vue?vue&type=style&index=0&id=d1fb6a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fb6a78",
  null
  
)

export default component.exports